import styled from "styled-components";

export const STFormWrapper = styled.form`
  display: flex;
  flex-flow: column nowrap;
  justify-content: space-between;
  align-items: center;
  min-height: 200px;
  width: 92%;
`;
